var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-frame"},[_c('iframe',{ref:"frame",attrs:{"id":"hidden-frame"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }